import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MessageService } from '@igo2/core/message';
import { DataSourceService, Feature, IgoMap, LayerService, VectorLayerOptions, WFSDataSource, WFSDataSourceOptions } from '@igo2/geo';
import { MapState } from '@igo2/integration';
import { Constantes } from 'src/app/shared/constantes';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { RechercheRdeService } from 'src/app/shared/services/recherche-rde.service';
import { EntityRecord, EntityTableButton, EntityTableColumnRenderer, EntityTableTemplate } from '@igo2/common/entity';
import * as olstyle from 'ol/style';
import { LanguageService } from '@igo2/core/language';
import { TransfertAuthoriteDto } from 'src/app/shared/models/transfert-authorite.dto';

@Component({
    selector: 'app-transfert-autorite',
    templateUrl: './transfert-autorite.component.html',
    styleUrls: ['./transfert-autorite.component.scss'],
    imports: [
        ReactiveFormsModule,
        TranslateModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatButtonModule,
        MatInputModule
    ]
})
export class TransfertAutoriteComponent implements OnInit {
  propertyKeyAndTitle: { [key: string]: string };
  template: EntityTableTemplate; 
  templateHistory: EntityTableTemplate; 
  style: olstyle.Style;
  
  layerid: string = 'RDETransfertAutorite';
  buttonClicked:boolean  = false;

  public form: UntypedFormGroup;
  messagesDeValidation: { [key: string]: string } = {};
  get map(): IgoMap {
    return this.mapState.map;
  }

  constructor(
    private rechercheRdeService: RechercheRdeService,
    private formBuilder: UntypedFormBuilder,
    private messageService: MessageService,
    private languageService: LanguageService,  
    private mapState: MapState,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
          const actionHandlers: Record<string,(row: any, record?: EntityRecord<object>) => void > = {
          details: (row, record) => {
            if (record?.state?.selected) {
              this.rechercheRdeService.obtenirFicheDescriptiveTA(row).subscribe({
                next: (blob: Blob) => {
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'Fiche - Transfert Autorité.pdf';
                  a.click();
                  window.URL.revokeObjectURL(url); // Clean up
                },
                error: (err) => {
                  console.error('Erreur lors du téléchargement du PDF', err);
                }
              });
            }
          }
        }
    
        this.template = this.rechercheRdeService.getEntityTableTemplate('transfertAutorite',actionHandlers);

    this.form = this.formBuilder.group({
      numeroTransfertAutorite: [""],
      dateDebut: new FormControl<Date | null>(null),
      dateFin: new FormControl<Date | null>(null)
    }, { validators: [this.validerUnChampRempli.bind(this), this.validerDateDebutFin.bind(this)] });

    this.form.valueChanges.subscribe(() => {
      if (this.form.valid) {
        this.buttonClicked = false;
      }
    });

    this.messagesDeValidation.dateDebutSuperieurFin = Constantes.MessageApplicatif.DateFinSuperieurDateDebut_15E;
    this.messagesDeValidation.listeVide = Constantes.MessageApplicatif.AucunElement_6I;
    this.messagesDeValidation.messageTechnique = Constantes.MessageApplicatif.CoucheIndisponible_16T;
    this.messagesDeValidation.grilleVide = Constantes.MessageApplicatif.AucunElement_6I;
    this.messagesDeValidation.erreurCouche = Constantes.MessageApplicatif.CoucheIndisponible_16T;
    this.messagesDeValidation.obligatoireNumero = Constantes.MessageApplicatif.ValeurObligatoire_1E
      .replace("{0}", this.getTitle('transfertAutorite.numeroTransfertAutorite'));       
  }

  onRechercher() {
    this.buttonClicked = true;
    this.rechercher();
  }
  rechercher() {
    const numeroTA = +this.form.get("numeroTransfertAutorite").value;
    const dateFin = this.form.get("dateFin").value;
    const dateDebut = this.form.get("dateDebut").value;
    const statut = ["IN", "CO"];
    
    this.rechercheRdeService.obtenirListeTransfertsAutorite( 
      statut, 
      numeroTA,
      dateDebut, 
      dateFin
    )
    .subscribe({
      next: reponse => {
        if (reponse?.length > 0){
          this.rechercheRdeService.addSearchResultsToMap(
            this.layerid, 
            this.rechercheRdeService.formatFeaturesForTable('transfertAutorite',reponse),
            this.cdRef,
            this.template,
            this.style
          )
        } else {
          this.messageService.info(this.messagesDeValidation.listeVide);
        }
      },
      error: error => {
        this.messageService.error(this.messagesDeValidation.erreurCouche);
        console.log(error);
      }
    });
  }
  validerUnChampRempli(controlGroup: FormGroup): { [key: string]: any } | null {
    const hasValue =
      controlGroup.controls["dateDebut"].value ||
        controlGroup.controls["numeroTransfertAutorite"].value
        ? true
        : false;
    return hasValue ? null : { requiredAtLeastOne: true };
  }

  validerDateDebutFin(controlGroup: FormGroup): { [key: string]: any } | null {
    const champDateDebut = controlGroup.controls["dateDebut"].value;
    const champDateFin = controlGroup.controls["dateFin"].value;
    if (champDateDebut && champDateFin) {
      const dateDebut = new Date(champDateDebut);
      const dateFin = new Date(champDateFin);
      if (dateDebut > dateFin) {
        this.messageService.error(this.messagesDeValidation.dateDebutSuperieurFin.replace('{0}', ''));
        return { dateDebutFinErreur: { message: this.messagesDeValidation.dateDebutSuperieurFin.replace('{0}', '') } };
      }
    }
    return null;
  }

    getTitle(key: string) {
        return this.languageService.translate.instant(`sigt.integration.rechercheRde.form.${key}`);
    }
}
